<template>
	<div class="demo">
		<h4>Using an array with user objects. Projecting the <code>email</code> property of the user object.</h4>
		<div class="row">
			<div class="column column-60">
				<span class="float-right">
					<code>({{ listFiltered.length }}/{{ list.length }})</code>
				</span>
				<vue3-simple-typeahead
					:items="list"
					:placeholder="options.placeholder"
					@selectItem="selectItem"
					@onInput="onInput"
					@onBlur="onBlur"
					:minInputLength="options.minInputLength"
					:itemProjection="
						(item) => {
							return item.email;
						}
					"
				/>
			</div>
			<div class="column column-40">
				<pre><code>{{data}}</code></pre>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Demo2',
	created() {
		this.listFiltered = this.list;
	},
	data() {
		return {
			options: {
				placeholder: 'Start writing a user email',
				minInputLength: 1,
			},
			list: [
				{
					id: 1,
					first_name: 'Geneva',
					last_name: 'Baniard',
					email: 'gbaniard0@tiny.cc',
					gender: 'Male',
					ip_address: '173.141.4.168',
				},
				{
					id: 2,
					first_name: 'Fritz',
					last_name: 'Rossin',
					email: 'frossin1@infoseek.co.jp',
					gender: 'Polygender',
					ip_address: '143.128.88.39',
				},
				{
					id: 3,
					first_name: 'Ainsley',
					last_name: 'Gorstidge',
					email: 'agorstidge2@samsung.com',
					gender: 'Male',
					ip_address: '238.68.22.152',
				},
				{
					id: 4,
					first_name: 'Oona',
					last_name: 'Kewley',
					email: 'okewley3@free.fr',
					gender: 'Genderfluid',
					ip_address: '170.206.201.131',
				},
				{
					id: 5,
					first_name: 'Zaria',
					last_name: 'Krysztofowicz',
					email: 'zkrysztofowicz4@accuweather.com',
					gender: 'Genderfluid',
					ip_address: '166.78.221.105',
				},
				{
					id: 6,
					first_name: 'Gratia',
					last_name: 'Prys',
					email: 'gprys5@gnu.org',
					gender: 'Polygender',
					ip_address: '74.58.255.245',
				},
				{
					id: 7,
					first_name: 'Hugh',
					last_name: 'Mannooch',
					email: 'hmannooch6@wiley.com',
					gender: 'Genderqueer',
					ip_address: '78.86.248.128',
				},
				{
					id: 8,
					first_name: 'Harbert',
					last_name: 'Valerius',
					email: 'hvalerius7@ycombinator.com',
					gender: 'Genderqueer',
					ip_address: '46.35.174.167',
				},
				{
					id: 9,
					first_name: 'Marmaduke',
					last_name: 'Jinkins',
					email: 'mjinkins8@google.cn',
					gender: 'Male',
					ip_address: '248.79.140.21',
				},
				{
					id: 10,
					first_name: 'Linnea',
					last_name: 'Lowthian',
					email: 'llowthian9@tuttocitta.it',
					gender: 'Polygender',
					ip_address: '96.225.12.79',
				},
				{
					id: 11,
					first_name: 'Archy',
					last_name: "O'Mahoney",
					email: 'aomahoneya@a8.net',
					gender: 'Genderfluid',
					ip_address: '183.214.5.140',
				},
				{
					id: 12,
					first_name: 'Ellissa',
					last_name: 'Oscroft',
					email: 'eoscroftb@yahoo.com',
					gender: 'Polygender',
					ip_address: '95.148.201.48',
				},
				{
					id: 13,
					first_name: 'Eleni',
					last_name: 'Feria',
					email: 'eferiac@wikia.com',
					gender: 'Genderfluid',
					ip_address: '91.253.176.190',
				},
				{
					id: 14,
					first_name: 'Hollie',
					last_name: 'Fredson',
					email: 'hfredsond@epa.gov',
					gender: 'Agender',
					ip_address: '164.126.222.23',
				},
				{
					id: 15,
					first_name: 'Florella',
					last_name: 'Thing',
					email: 'fthinge@fc2.com',
					gender: 'Male',
					ip_address: '51.173.186.151',
				},
				{
					id: 16,
					first_name: 'Fifi',
					last_name: 'Cluff',
					email: 'fclufff@zdnet.com',
					gender: 'Polygender',
					ip_address: '233.42.56.164',
				},
				{
					id: 17,
					first_name: 'Dawna',
					last_name: 'Mackinder',
					email: 'dmackinderg@marketwatch.com',
					gender: 'Male',
					ip_address: '26.149.5.88',
				},
				{
					id: 18,
					first_name: 'Tallia',
					last_name: 'Vogt',
					email: 'tvogth@facebook.com',
					gender: 'Female',
					ip_address: '70.42.83.67',
				},
				{
					id: 19,
					first_name: 'Deeyn',
					last_name: 'Tomlett',
					email: 'dtomletti@archive.org',
					gender: 'Genderfluid',
					ip_address: '6.49.62.119',
				},
				{
					id: 20,
					first_name: 'Chad',
					last_name: 'Howsden',
					email: 'chowsdenj@yahoo.com',
					gender: 'Male',
					ip_address: '63.11.212.111',
				},
				{
					id: 21,
					first_name: 'Philippe',
					last_name: 'Folke',
					email: 'pfolkek@nhs.uk',
					gender: 'Non-binary',
					ip_address: '94.158.132.38',
				},
				{
					id: 22,
					first_name: 'Kristo',
					last_name: 'Fullun',
					email: 'kfullunl@deviantart.com',
					gender: 'Polygender',
					ip_address: '62.135.100.223',
				},
				{
					id: 23,
					first_name: 'Janka',
					last_name: 'Winnard',
					email: 'jwinnardm@blogger.com',
					gender: 'Genderqueer',
					ip_address: '196.231.34.147',
				},
				{
					id: 24,
					first_name: 'Zoe',
					last_name: 'Fransseni',
					email: 'zfranssenin@merriam-webster.com',
					gender: 'Bigender',
					ip_address: '201.109.133.68',
				},
				{
					id: 25,
					first_name: 'Shanie',
					last_name: 'Eadmeads',
					email: 'seadmeadso@whitehouse.gov',
					gender: 'Male',
					ip_address: '23.117.26.213',
				},
				{
					id: 26,
					first_name: 'Brittani',
					last_name: 'Aluard',
					email: 'baluardp@studiopress.com',
					gender: 'Male',
					ip_address: '171.67.21.194',
				},
				{
					id: 27,
					first_name: 'Malorie',
					last_name: 'Hubbock',
					email: 'mhubbockq@noaa.gov',
					gender: 'Genderqueer',
					ip_address: '50.183.67.173',
				},
				{
					id: 28,
					first_name: 'Dosi',
					last_name: 'Colliford',
					email: 'dcollifordr@amazon.de',
					gender: 'Genderfluid',
					ip_address: '91.109.135.40',
				},
				{
					id: 29,
					first_name: 'Gerrie',
					last_name: 'Josef',
					email: 'gjosefs@tripadvisor.com',
					gender: 'Agender',
					ip_address: '203.216.221.76',
				},
				{
					id: 30,
					first_name: 'Esme',
					last_name: 'Beckinsall',
					email: 'ebeckinsallt@ihg.com',
					gender: 'Agender',
					ip_address: '91.136.182.109',
				},
				{
					id: 31,
					first_name: 'Lilith',
					last_name: 'Lingwood',
					email: 'llingwoodu@answers.com',
					gender: 'Male',
					ip_address: '233.30.227.5',
				},
				{
					id: 32,
					first_name: 'Deane',
					last_name: 'Ringsell',
					email: 'dringsellv@cpanel.net',
					gender: 'Agender',
					ip_address: '201.87.15.233',
				},
				{
					id: 33,
					first_name: 'Carita',
					last_name: 'Marcus',
					email: 'cmarcusw@ebay.co.uk',
					gender: 'Female',
					ip_address: '63.97.207.236',
				},
				{
					id: 34,
					first_name: 'Neely',
					last_name: 'Nickoles',
					email: 'nnickolesx@squidoo.com',
					gender: 'Genderqueer',
					ip_address: '170.230.96.0',
				},
				{
					id: 35,
					first_name: 'Jourdan',
					last_name: 'Guidera',
					email: 'jguideray@seesaa.net',
					gender: 'Bigender',
					ip_address: '141.34.64.166',
				},
				{
					id: 36,
					first_name: 'Moritz',
					last_name: 'Jedrzejewicz',
					email: 'mjedrzejewiczz@dailymotion.com',
					gender: 'Polygender',
					ip_address: '241.32.235.167',
				},
				{
					id: 37,
					first_name: 'Keefer',
					last_name: 'Kemitt',
					email: 'kkemitt10@ft.com',
					gender: 'Male',
					ip_address: '240.102.227.136',
				},
				{
					id: 38,
					first_name: 'Merv',
					last_name: 'Fairey',
					email: 'mfairey11@auda.org.au',
					gender: 'Genderfluid',
					ip_address: '141.188.45.67',
				},
				{
					id: 39,
					first_name: 'Maurise',
					last_name: 'Confort',
					email: 'mconfort12@xinhuanet.com',
					gender: 'Male',
					ip_address: '250.226.79.90',
				},
				{
					id: 40,
					first_name: 'Seka',
					last_name: 'Barstock',
					email: 'sbarstock13@va.gov',
					gender: 'Male',
					ip_address: '251.217.155.77',
				},
				{
					id: 41,
					first_name: 'Jessee',
					last_name: 'Sill',
					email: 'jsill14@usgs.gov',
					gender: 'Genderqueer',
					ip_address: '10.167.67.155',
				},
				{
					id: 42,
					first_name: 'Fax',
					last_name: 'Forsyde',
					email: 'fforsyde15@people.com.cn',
					gender: 'Agender',
					ip_address: '6.241.104.166',
				},
				{
					id: 43,
					first_name: 'Ave',
					last_name: 'Spoole',
					email: 'aspoole16@livejournal.com',
					gender: 'Polygender',
					ip_address: '101.235.165.180',
				},
				{
					id: 44,
					first_name: 'Arlyn',
					last_name: 'Skune',
					email: 'askune17@cisco.com',
					gender: 'Genderqueer',
					ip_address: '206.101.101.98',
				},
				{
					id: 45,
					first_name: 'Ame',
					last_name: 'Dovington',
					email: 'adovington18@google.co.uk',
					gender: 'Genderqueer',
					ip_address: '106.64.118.108',
				},
				{
					id: 46,
					first_name: 'Bennie',
					last_name: 'Koeppke',
					email: 'bkoeppke19@aol.com',
					gender: 'Polygender',
					ip_address: '28.171.191.150',
				},
				{
					id: 47,
					first_name: 'Lynelle',
					last_name: 'Pedrick',
					email: 'lpedrick1a@netscape.com',
					gender: 'Bigender',
					ip_address: '22.158.238.134',
				},
				{
					id: 48,
					first_name: 'Laurie',
					last_name: 'Andreucci',
					email: 'landreucci1b@census.gov',
					gender: 'Female',
					ip_address: '232.245.230.176',
				},
				{
					id: 49,
					first_name: 'Tobit',
					last_name: 'Lambert-Ciorwyn',
					email: 'tlambertciorwyn1c@google.co.jp',
					gender: 'Male',
					ip_address: '46.217.108.147',
				},
				{
					id: 50,
					first_name: 'Bonita',
					last_name: 'MacNeilley',
					email: 'bmacneilley1d@domainmarket.com',
					gender: 'Agender',
					ip_address: '92.188.184.153',
				},
				{
					id: 51,
					first_name: 'Bryon',
					last_name: 'McAless',
					email: 'bmcaless1e@fc2.com',
					gender: 'Non-binary',
					ip_address: '152.206.119.216',
				},
				{
					id: 52,
					first_name: 'Regina',
					last_name: 'Cockill',
					email: 'rcockill1f@army.mil',
					gender: 'Female',
					ip_address: '251.52.81.170',
				},
				{
					id: 53,
					first_name: 'Aileen',
					last_name: 'Ringer',
					email: 'aringer1g@wired.com',
					gender: 'Genderqueer',
					ip_address: '90.252.109.12',
				},
				{
					id: 54,
					first_name: 'Zane',
					last_name: 'Laying',
					email: 'zlaying1h@dropbox.com',
					gender: 'Male',
					ip_address: '242.86.243.204',
				},
				{
					id: 55,
					first_name: 'Maxi',
					last_name: 'Wheater',
					email: 'mwheater1i@ft.com',
					gender: 'Genderfluid',
					ip_address: '178.147.51.229',
				},
				{
					id: 56,
					first_name: 'Vaughn',
					last_name: 'Klee',
					email: 'vklee1j@nbcnews.com',
					gender: 'Agender',
					ip_address: '197.185.232.122',
				},
				{
					id: 57,
					first_name: 'Carmella',
					last_name: 'Breitler',
					email: 'cbreitler1k@usnews.com',
					gender: 'Genderfluid',
					ip_address: '235.225.55.151',
				},
				{
					id: 58,
					first_name: 'Aileen',
					last_name: 'Johnsey',
					email: 'ajohnsey1l@xing.com',
					gender: 'Bigender',
					ip_address: '205.24.175.93',
				},
				{
					id: 59,
					first_name: 'Vic',
					last_name: 'Cuerdale',
					email: 'vcuerdale1m@github.io',
					gender: 'Non-binary',
					ip_address: '222.8.118.203',
				},
				{
					id: 60,
					first_name: 'Gray',
					last_name: 'Teasell',
					email: 'gteasell1n@fotki.com',
					gender: 'Genderqueer',
					ip_address: '172.128.187.109',
				},
				{
					id: 61,
					first_name: 'Idell',
					last_name: 'Roeby',
					email: 'iroeby1o@amazon.de',
					gender: 'Female',
					ip_address: '183.142.8.78',
				},
				{
					id: 62,
					first_name: 'Valery',
					last_name: 'Fronks',
					email: 'vfronks1p@fc2.com',
					gender: 'Genderfluid',
					ip_address: '187.27.105.217',
				},
				{
					id: 63,
					first_name: 'Madelaine',
					last_name: 'Hadleigh',
					email: 'mhadleigh1q@etsy.com',
					gender: 'Female',
					ip_address: '109.19.158.68',
				},
				{
					id: 64,
					first_name: 'Stillmann',
					last_name: 'MacMeanma',
					email: 'smacmeanma1r@alexa.com',
					gender: 'Genderfluid',
					ip_address: '52.248.82.198',
				},
				{
					id: 65,
					first_name: 'Josiah',
					last_name: 'Bartlam',
					email: 'jbartlam1s@free.fr',
					gender: 'Genderfluid',
					ip_address: '45.178.202.211',
				},
				{
					id: 66,
					first_name: 'Aurelie',
					last_name: 'Gronowe',
					email: 'agronowe1t@comcast.net',
					gender: 'Bigender',
					ip_address: '165.224.97.185',
				},
				{
					id: 67,
					first_name: 'Hedi',
					last_name: 'Redmile',
					email: 'hredmile1u@yolasite.com',
					gender: 'Male',
					ip_address: '171.129.146.76',
				},
				{
					id: 68,
					first_name: 'Clare',
					last_name: 'Mingay',
					email: 'cmingay1v@photobucket.com',
					gender: 'Non-binary',
					ip_address: '146.160.233.218',
				},
				{
					id: 69,
					first_name: 'Celia',
					last_name: 'Matson',
					email: 'cmatson1w@amazon.com',
					gender: 'Agender',
					ip_address: '1.78.223.57',
				},
				{
					id: 70,
					first_name: 'Jaine',
					last_name: 'Woolgar',
					email: 'jwoolgar1x@deviantart.com',
					gender: 'Bigender',
					ip_address: '69.232.164.99',
				},
				{
					id: 71,
					first_name: 'Kermy',
					last_name: 'Western',
					email: 'kwestern1y@baidu.com',
					gender: 'Female',
					ip_address: '248.126.223.248',
				},
				{
					id: 72,
					first_name: 'Katey',
					last_name: 'Kilshaw',
					email: 'kkilshaw1z@dell.com',
					gender: 'Polygender',
					ip_address: '245.125.49.75',
				},
				{
					id: 73,
					first_name: 'Zechariah',
					last_name: 'Nolan',
					email: 'znolan20@gov.uk',
					gender: 'Bigender',
					ip_address: '194.224.29.5',
				},
				{
					id: 74,
					first_name: 'Patrizio',
					last_name: 'Givens',
					email: 'pgivens21@dell.com',
					gender: 'Genderqueer',
					ip_address: '234.210.86.214',
				},
				{
					id: 75,
					first_name: 'Sigmund',
					last_name: 'Terzo',
					email: 'sterzo22@ebay.com',
					gender: 'Genderqueer',
					ip_address: '250.239.193.209',
				},
				{
					id: 76,
					first_name: 'Jacquelyn',
					last_name: 'Berns',
					email: 'jberns23@indiegogo.com',
					gender: 'Bigender',
					ip_address: '148.174.99.16',
				},
				{
					id: 77,
					first_name: 'Tobye',
					last_name: 'Dennerly',
					email: 'tdennerly24@vk.com',
					gender: 'Non-binary',
					ip_address: '117.244.95.167',
				},
				{
					id: 78,
					first_name: 'Natale',
					last_name: 'Sextie',
					email: 'nsextie25@barnesandnoble.com',
					gender: 'Male',
					ip_address: '20.110.37.52',
				},
				{
					id: 79,
					first_name: 'Paquito',
					last_name: 'Thulborn',
					email: 'pthulborn26@oakley.com',
					gender: 'Agender',
					ip_address: '105.227.161.250',
				},
				{
					id: 80,
					first_name: 'Lorin',
					last_name: 'Denness',
					email: 'ldenness27@pbs.org',
					gender: 'Genderfluid',
					ip_address: '239.115.126.49',
				},
				{
					id: 81,
					first_name: 'Bendite',
					last_name: 'Fernandes',
					email: 'bfernandes28@usnews.com',
					gender: 'Genderqueer',
					ip_address: '76.62.76.2',
				},
				{
					id: 82,
					first_name: 'Iosep',
					last_name: 'Bolderstone',
					email: 'ibolderstone29@nymag.com',
					gender: 'Female',
					ip_address: '215.30.207.86',
				},
				{
					id: 83,
					first_name: 'Maryanna',
					last_name: 'McKissack',
					email: 'mmckissack2a@bloglovin.com',
					gender: 'Genderfluid',
					ip_address: '67.218.106.68',
				},
				{
					id: 84,
					first_name: 'Kellyann',
					last_name: 'Knightley',
					email: 'kknightley2b@blogger.com',
					gender: 'Bigender',
					ip_address: '65.248.61.222',
				},
				{
					id: 85,
					first_name: 'Tobi',
					last_name: 'Partlett',
					email: 'tpartlett2c@jigsy.com',
					gender: 'Male',
					ip_address: '72.113.66.168',
				},
				{
					id: 86,
					first_name: 'Marie-ann',
					last_name: 'Sparkwill',
					email: 'msparkwill2d@zimbio.com',
					gender: 'Polygender',
					ip_address: '157.240.46.226',
				},
				{
					id: 87,
					first_name: 'Tiffy',
					last_name: 'Mahedy',
					email: 'tmahedy2e@google.cn',
					gender: 'Polygender',
					ip_address: '48.93.133.11',
				},
				{
					id: 88,
					first_name: 'Saudra',
					last_name: 'Hanalan',
					email: 'shanalan2f@360.cn',
					gender: 'Bigender',
					ip_address: '80.152.125.2',
				},
				{
					id: 89,
					first_name: 'Juline',
					last_name: 'Audritt',
					email: 'jaudritt2g@typepad.com',
					gender: 'Female',
					ip_address: '43.37.110.143',
				},
				{
					id: 90,
					first_name: 'Pearle',
					last_name: "O'Cullinane",
					email: 'pocullinane2h@cbc.ca',
					gender: 'Genderfluid',
					ip_address: '142.4.107.195',
				},
				{
					id: 91,
					first_name: 'Erastus',
					last_name: 'Marczyk',
					email: 'emarczyk2i@hatena.ne.jp',
					gender: 'Polygender',
					ip_address: '14.5.216.34',
				},
				{
					id: 92,
					first_name: 'Sascha',
					last_name: 'Jantzen',
					email: 'sjantzen2j@nba.com',
					gender: 'Genderqueer',
					ip_address: '198.24.89.9',
				},
				{
					id: 93,
					first_name: 'Suzie',
					last_name: 'Gehrts',
					email: 'sgehrts2k@odnoklassniki.ru',
					gender: 'Polygender',
					ip_address: '102.42.69.68',
				},
				{
					id: 94,
					first_name: 'Adham',
					last_name: 'Juara',
					email: 'ajuara2l@rediff.com',
					gender: 'Non-binary',
					ip_address: '131.185.42.40',
				},
				{
					id: 95,
					first_name: 'Avril',
					last_name: 'Sarson',
					email: 'asarson2m@surveymonkey.com',
					gender: 'Genderfluid',
					ip_address: '94.86.79.72',
				},
				{
					id: 96,
					first_name: 'Babita',
					last_name: 'Berk',
					email: 'bberk2n@theatlantic.com',
					gender: 'Bigender',
					ip_address: '203.216.248.181',
				},
				{
					id: 97,
					first_name: 'Gustav',
					last_name: 'Gater',
					email: 'ggater2o@typepad.com',
					gender: 'Female',
					ip_address: '131.209.109.125',
				},
				{
					id: 98,
					first_name: 'Tonie',
					last_name: 'Weatherhead',
					email: 'tweatherhead2p@wordpress.com',
					gender: 'Female',
					ip_address: '51.204.46.42',
				},
				{
					id: 99,
					first_name: 'Elnora',
					last_name: 'Nail',
					email: 'enail2q@amazon.de',
					gender: 'Male',
					ip_address: '187.81.56.130',
				},
				{
					id: 100,
					first_name: 'Brinn',
					last_name: 'Doylend',
					email: 'bdoylend2r@springer.com',
					gender: 'Agender',
					ip_address: '214.11.148.109',
				},
			],
			listFiltered: [],
			data: {
				input: '',
				selection: null,
			},
		};
	},
	methods: {
		selectItem(item) {
			this.data.selection = item;
		},
		onInput(event) {
			this.data.selection = null;
			this.data.input = event.input;
			this.listFiltered = event.items;
		},
		onBlur(event) {
			this.data.input = event.input;
			this.listFiltered = event.items;
		},
	},
};
</script>

<style scoped>
.demo:deep() .simple-typeahead-list {
	max-height: 200px !important;
}
</style>
